import { render, staticRenderFns } from "./AssumptionsImpactsPenetrationRate.vue?vue&type=template&id=639d8c72&"
import script from "./AssumptionsImpactsPenetrationRate.vue?vue&type=script&lang=js&"
export * from "./AssumptionsImpactsPenetrationRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports